import React, { useEffect, useState } from 'react'
import { BackArrowFeed, PersonalizedWellnessHubIcon } from '../../utils/icons'
import {  WellnessHubHeading } from './styles'
import WellnessSlider from '../../components/UserDashboard/WellnessSlider';
import { GetArticlesById,GetFitnessVideosById,GetRecipesById } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import { fetchApi } from '../../utils/methods';
import CommonWellnessCard from './CommonWellnessCard';
// import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

function CategoryDetailsPage() {


  
  const location = useLocation();
  const categoryData = location.state?.categoryData;
  const type = location?.state?.type;
  const CatgoryId = categoryData?.id;
  const CategoryType = categoryData?.type || type;
  const CatgoryName = categoryData?.category_name;



  // const [articlesData, setArticlesData] = useState([]);
  // const [finessData, setFitnessData] = useState([]);
  const [wellnessData, setWellnessData] = useState([]);
  const [trendingData, setTrendingData] = useState([]);
  const [recommendedData, setRecommendedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  // const recommendedRecipes = useSelector((state) => state.education.recommendedRecipes);




  useEffect(()=>{
    GetArticlesData(CatgoryId, CategoryType);
  },[])

 
    

  const GetArticlesData= async (CatgoryId, CatgoryType) => {

    let apiUrl = "";  

    if (CatgoryType === "article") {
      apiUrl = GetArticlesById + "/" + CatgoryId;
    } 
    else if (CatgoryType === "fitness_video") {
      apiUrl = GetFitnessVideosById + "/" + CatgoryId;
    } 
    else if (CatgoryType === "recipe") {
      apiUrl = GetRecipesById + "/" + CatgoryId;
    }
  
    if (!apiUrl) {
      window.console.error("Invalid Category Type");
      return;
    }
  
    // const apiUrl = GetArticlesById + "/" + CatgoryId;
    setLoading(true);
    try{
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        if (CatgoryType === "article") {
          setWellnessData(res.data.featured_articles);
          setTrendingData(res.data.trending_articles);
          setRecommendedData(res.data.recommended_articles);
        } else if (CatgoryType === "fitness_video") {
          setWellnessData(res.data.featured_fitness_videos);
          setTrendingData(res.data.trending_fitness_videos);
          setRecommendedData(res.data.recommended_fitness_videos);
        } else if (CatgoryType === "recipe") {
          setWellnessData(res.data.featured_recipes);
          setTrendingData(res.data.trending_recipes);
          setRecommendedData(res.data.recommended_recipes);
        }
        setLoading(false);
      }
      else{
        toast.error(res.message);
        setLoading(false);
      }
    }catch(error){
      window.console.error(error);

    }
  }


  const FeaturedCard = () => (
    <WellnessSlider
      title="Recommended"   
      data={wellnessData} 
      showArrows={true} 
      showDots={true}
      myFocusCard={true}
      loading={loading} 
      icon={<PersonalizedWellnessHubIcon/>}
      CategoryType={CategoryType}
      CatgoryName={CatgoryName}
    />
  );

  const TrendingCard = () => (
    <CommonWellnessCard
      title="Trending"  
      showArrows={true} 
      data={trendingData} 
      showDots={false}
      loading={false} 
      history={history}
      CategoryType={CategoryType}
      CatgoryName={CatgoryName}
      GetArticlesData={GetArticlesData}
      CatgoryId={CatgoryId}

    />
  )

  const RecommendedCard = () => (
    <CommonWellnessCard
      title="Featured" 
      showArrows={true} 
      data={recommendedData} 
      showDots={false}
      loading={false} 
      history={history}
      CategoryType={CategoryType}
      CatgoryName={CatgoryName}
      GetArticlesData={GetArticlesData}
      CatgoryId={CatgoryId}
    />
  )
 



  return (
    <div style={{maxWidth: "1246px", padding: "24px 0px 40px 0px",margin: "auto",width: "100%"}}>
      <WellnessHubHeading>
        <div className='right-row'>
          <div className="icon" onClick={() => history.push("/wellness-resources")}>
            {BackArrowFeed("#DA6C74")}
          </div>
          <div className="title">{CatgoryName}</div>
        </div>
      </WellnessHubHeading>
      {wellnessData.length ? FeaturedCard() : null}
      {trendingData.length ? TrendingCard() : null}
      {recommendedData.length ? RecommendedCard() :null}
    </div>
  )
}

export default CategoryDetailsPage;
